import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useStrictLocalization } from "@faire/web--source/common/localization";
import { Spacer } from "@faire/web--source/slate/spacing";
import React from "react";
import { Context } from "@faire/retailer/components/LayoutElementRenderer/__internal__/Context";
import { AppDownloadPromoBanner } from "@faire/retailer/components/MobileAppPromoBanner/AppDownloadPromoBanner";
export var AppPromotionBanner = function() {
    var strictLocalize = useStrictLocalization().strictLocalize;
    var _React_useContext = React.useContext(Context), onCTAClick = _React_useContext.onCTAClick, layoutElement = _React_useContext.layoutElement, requestId = _React_useContext.requestId;
    var handleClick = function() {
        var _layoutElement_on_click_event_name;
        onCTAClick === null || onCTAClick === void 0 ? void 0 : onCTAClick((_layoutElement_on_click_event_name = layoutElement.on_click_event_name) !== null && _layoutElement_on_click_event_name !== void 0 ? _layoutElement_on_click_event_name : "AppPromotionBanner", requestId);
    };
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(Spacer, {
                height: {
                    mobileAndAbove: "3x",
                    tabletAndAbove: 0
                }
            }),
            /*#__PURE__*/ _jsx(AppDownloadPromoBanner, {
                header: useHeaderText(),
                body: strictLocalize({
                    id: "kB2G1V",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Enter your phone number and we'll text you a link to download the Faire app."
                        }
                    ]
                }),
                onClick: handleClick
            })
        ]
    });
};
var useHeaderText = function() {
    var strictLocalize = useStrictLocalization().strictLocalize;
    return strictLocalize({
        id: "s7H2Sy",
        defaultMessage: [
            {
                type: 0,
                value: "Shop thousands of brands on the go"
            }
        ]
    });
};
